module.exports = __webpack_public_path__ + "fa5c2179d594d6088214a35c97e0aa95.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/brokerage/home.png
// module id = 706
// module chunks = 0